import { module } from 'modujs'

export default class extends module {
    constructor(m) {
        super(m);



    }

    init() {
        console.log('Header Toggle')
    }


     
    destroy() {
      super.destroy()
    }
}
